import React, { FC, useState } from 'react';

import RadioSelectScrollable, {
    RadioSelectOption,
} from '../../../../../../components/inputs/RadioSelectScrollable';
import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';
import ICONS from '../../../../../../constants/icons';

interface DatasetColumnSelectProps {
    columnOptions: RadioSelectOption[];
    selectedColumn?: string;
    onApply: (id: string) => void;
}

const DatasetColumnSelect: FC<DatasetColumnSelectProps> = ({
    columnOptions,
    selectedColumn,
    onApply,
}) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const handleApply = (val: string) => {
        onApply(val);
        setIsPopoverOpen(false);
    };

    return (
        <SelectColumnContainer>
            <SelectColumnHeading>
                Column to insert in the message
            </SelectColumnHeading>
            <PopoverTrigger onClick={() => setIsPopoverOpen((prev) => !prev)}>
                {selectedColumn
                    ? columnOptions?.find(
                          (option) => option.value === selectedColumn,
                      )?.label
                    : 'Select'}
                {isPopoverOpen ? <StyledUpIcon /> : <StyledDownIcon />}
            </PopoverTrigger>
            {isPopoverOpen && (
                <RadioPopover>
                    <RadioSelectScrollable
                        options={columnOptions}
                        selected={selectedColumn ?? ''}
                        onApply={handleApply}
                    />
                </RadioPopover>
            )}
        </SelectColumnContainer>
    );
};

export default DatasetColumnSelect;

// Styles
const SelectColumnContainer = styled.div({
    display: 'flex',
    position: 'relative',
    gap: aampeTheme.spacing4(2),
    alignItems: 'center',
    padding: aampeTheme.spacing4(2, 3),
    backgroundColor: aampeTheme.colors.white,
    borderRadius: aampeTheme.borderRadius.medium,
});

const SelectColumnHeading = styled.div({
    color: aampeTheme.colors.textAccessibleWG01,
});

const PopoverTrigger = styled.div({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontWeight: aampeTheme.weights.medium,
    color: aampeTheme.colors.solidA01,
    gap: aampeTheme.spacing4(2),
});

const RadioPopover = styled.div({
    position: 'absolute',
    bottom: '100%',
    left: 200,
    marginBottom: aampeTheme.spacing4(2),
    zIndex: 1000,
});

const commonStyle = {
    cursor: 'pointer',
    color: aampeTheme.colors.solidA01,
    height: '20px',
    width: '20px',
};

const StyledUpIcon = styled(ICONS.chevronUp)(() => commonStyle);
const StyledDownIcon = styled(ICONS.chevronDown)(commonStyle);
